import { type FC, useCallback, useMemo } from 'react';
import { batch } from 'react-redux';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { useMapSelectedBoundsSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { Tag } from './internal/components/Tag';

const useBoundActions = boundActionsFactory(reduxActions => ({
  clearSelectedBounds: reduxActions.mapControls.clearSelectedBounds,
  setIsCurrentAreaSearchActive: reduxActions.mapControls.setIsCurrentAreaSearchActive,
}));

export const TagsContainer: FC = () => {
  const boundActions = useBoundActions();
  const selectedBounds = useMapSelectedBoundsSelector();

  const handleAreaSearchTagClose = useCallback(() => {
    batch(() => {
      boundActions.clearSelectedBounds();
      boundActions.setIsCurrentAreaSearchActive(true);
    });
  }, [boundActions]);

  return useMemo<JSX.Element[] | null>(() => {
    const tagsCollection = [];

    if (selectedBounds) {
      tagsCollection.push(
        <Tag handleClose={handleAreaSearchTagClose} key="area_search" testId="map-tags.area-search">
          Область поиска
        </Tag>,
      );
    }

    return tagsCollection.length ? tagsCollection : null;
  }, [selectedBounds, handleAreaSearchTagClose]);
};
